// Configuration utilities for the application

/**
 * Get the API base URL based on environment
 * In development: uses localhost
 * In production: detects Netlify/Vercel and adjusts accordingly
 * Can be overridden with VITE_API_URL environment variable
 */
export const getApiUrl = (): string => {
  // If explicitly configured, use that
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL
  }

  // In development (Vite dev server), default to localhost:3001
  if (import.meta.env.DEV) {
    return 'http://localhost:3001'
  }

  // In production, detect platform and adjust
  const hostname = window.location.hostname
  
  // Vercel deployment - use same origin for /api routes
  if (hostname.includes('vercel.app') || hostname.includes('.app')) {
    return window.location.origin
  }
  
  // Firebase Hosting deployment
  if (hostname.includes('firebaseapp.com') || hostname.includes('web.app')) {
    return 'https://us-central1-fretpractice.cloudfunctions.net' // Firebase Functions URL
  }
  
  // Netlify deployment
  if (hostname.includes('netlify.app') || hostname.includes('netlify.com')) {
    return '' // Use relative paths for Netlify Functions (/.netlify/functions/*)
  }
  
  // For other platforms, use same origin
  return window.location.origin
}

/**
 * Build a full API endpoint URL
 */
export const buildApiUrl = (endpoint: string): string => {
  const baseUrl = getApiUrl()
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`
  return `${baseUrl}${cleanEndpoint}`
}